import { makeStyles, createStyles } from '@material-ui/core';
import './style.css';

export const useStyles = makeStyles(() =>
  createStyles({
    formInputWithErrors: {
      marginBottom: '45px',
    },
    subHeader: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '13px',
      paddingBottom: '8px',
    },
    subHeaderParagraph: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '13px',
      marginBottom: '5px',
    },
    formInputNarrow: {
      margin: '15px 10px',
      width: '165px',
      borderRadius: '3px',
      appearance: 'none',
    },
    formInputNarrowContainer: {
      width: '450px',
    },
    formInputNarrowContainerWithError: {
      marginBottom: '20px',
    },
    formInputScoreContainer: {
      width: '355px',
      overflow: 'auto',
      flexDirection: 'row',
      borderRadius: '5px',
      paddingTop: '2px',
      paddingBottom: '2px',
    },
    formInputScoreContainerBackGround: {
      backgroundColor: 'rgba(60, 65, 154, 0.2)',
      width: '360px',
      overflow: 'auto',
      flexDirection: 'row',
      borderRadius: '5px',
      paddingTop: '2px',
      paddingBottom: '2px',
    },
    formInputScore: {
      margin: '2px 12px',
      width: '100px',
      borderRadius: '5px',
      background: '#FFFFFF',
    },
    scoreContainer: {
      display: 'inline-flex',
      width: '50px',
      border: 'solid 1px rgba(44, 45, 62, 0.3)',
      borderRadius: '5px',
      background: '#FFFFFF',
      margin: '2.5px 2.5px 2.5px 2.5px',
    },
    checkbox: {
      margin: '0px',
      padding: '0px 2px 0px 10px',
    },
    switch: {
      marginTop: '-15px',
    },
    line: {
      position: 'relative',
      width: '165%',
      margin: '10px -10px 10px -100',
      size: '0px',
      color: '#2c2d3e',
      opacity: 0.3,
      display: 'inline-block',
    },
    schemeScoreWithCheckbox: {
      display: 'inline-flex',
    },
  }),
);
